export default "__VITE_ASSET__C8c5kz9Y__"